import { useEffect } from "react";

/**
 * Keeps the tab title honest as the SPA moves between screens — without it
 * every dashboard tab reads a bare "Koaform" and five open forms are
 * indistinguishable in the tab strip.
 */
export const usePageTitle = (title?: string) => {
  useEffect(() => {
    const trimmed = title?.trim();
    document.title = trimmed ? `${trimmed} · Koaform` : "Koaform";
    return () => {
      document.title = "Koaform";
    };
  }, [title]);
};
